export class VerifyEmailRequest {
    public verificationToken: string;
    public languageId: number;
  }
  